import type React from 'react';

import * as styles from './styles';
import ChecklistItemOption from './ChecklistItemOption';
import type { ChecklistFormProps } from './formProps';
import {
  FieldArray,
  type FieldArrayRenderProps,
  useFormikContext,
} from 'formik';

import type { ChecklistSelectOptionContent } from '@cobliteam/api-lib';

import { Button } from '@cobliteam/ui/components';

import AddRoundedIcon from '@material-ui/icons/AddRounded';

export const getChecklistOptionsMetadata = (checklistContentMd: string) =>
  `${checklistContentMd}.options`;

export const emptyOptionContent = {
  label: '',
  checked: null,
};

export interface ChecklistItemOptionsProps {
  index: number;
  contentMd: string;
}

const ChecklistItemOptions: React.FC<ChecklistItemOptionsProps> = ({
  index,
  contentMd,
}) => {
  const { values } = useFormikContext<ChecklistFormProps>();
  const checklistContent = values.checklistItems[index].content;

  const handleAddChecklistOption =
    (arrayHelpers: FieldArrayRenderProps) => () => {
      arrayHelpers.push(emptyOptionContent);
    };

  const handleDeleteChecklistOption =
    (arrayHelpers: FieldArrayRenderProps, optionIndex: number) => () => {
      arrayHelpers.remove(optionIndex);
    };

  if ('options' in checklistContent) {
    const checklistOptions = checklistContent.options;
    const checklistOptionsMd = getChecklistOptionsMetadata(contentMd);

    return (
      <FieldArray
        name={checklistOptionsMd}
        render={(arrayHelpers) => (
          <div className={styles.checklistItemOptions}>
            {checklistOptions.map(
              (_: ChecklistSelectOptionContent, optionIndex: number) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={optionIndex} className={styles.checklistOption}>
                  <ChecklistItemOption
                    index={optionIndex}
                    hasMultipleOptions={checklistOptions.length > 1}
                    optionsMd={checklistOptionsMd}
                    handleDeleteClick={handleDeleteChecklistOption(
                      arrayHelpers,
                      optionIndex
                    )}
                  />
                </div>
              )
            )}
            <Button
              variant='text'
              color='secondary'
              startIcon={<AddRoundedIcon />}
              className='mt-4'
              onClick={handleAddChecklistOption(arrayHelpers)}
            >
              Opção
            </Button>
          </div>
        )}
      />
    );
  }

  return null;
};

export default ChecklistItemOptions;
